import { useState, forwardRef, useImperativeHandle } from 'react';
import PropTypes from "prop-types";
import { Divider, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

function MapItConfirmDialog({
    title,
    content,
    confirmAction,
    pendingDelete,
    ...props
}, ref) {
    const { t } = useTranslation()
    const [open, setOpen] = useState(false);

    const openConfirmDialog = () => {
        setOpen(true);
    };
    const closeConfirmDialog = () => {
        setOpen(false);
    };

    useImperativeHandle(ref, () => ({
        openConfirmDialog,
        closeConfirmDialog
    }))

    return (
        <Dialog
            open={open}
            onClose={(e) => e.preventDefault()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            {...props}
        >
            <DialogTitle id="alert-dialog-title">
                {title}
            </DialogTitle>
            <Divider />
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {content}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button sx={{
                    textTransform: "none",
                }} variant='contained' color='main' onClick={closeConfirmDialog}>{t("Close")}</Button>
                <Button sx={{
                    textTransform: "none",
                    mx: '4px'
                }} variant='contained' color='main' onClick={() => {
                    confirmAction()
                    closeConfirmDialog()
                }} autoFocus>
                    {t("Confirm")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

MapItConfirmDialog.propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    confirmAction: PropTypes.func.isRequired,
    pendingDelete: PropTypes.bool,
};

MapItConfirmDialog = forwardRef(MapItConfirmDialog)
export default MapItConfirmDialog;